import { useEffect, useState } from "react";
import api from "@/lib/api";

// CC-188: per-tech alt-key state. Payroll readers only; others get 403 and see nothing.
export function useAltKeyStatus(tenantSlug) {
  const [techs, setTechs] = useState({});
  useEffect(() => {
    if (!tenantSlug) return;
    api.get("/payroll/alt-key/status", { params: { tenant_slug: tenantSlug } })
      .then(({ data }) => setTechs(data?.techs || {}))
      .catch(() => setTechs({}));
  }, [tenantSlug]);
  return techs;
}

export const AltKeyBadge = ({ status, testId }) => {
  if (!status?.label) return null;
  const alt = status.on_alt_rate;
  return (
    <div
      data-testid={testId}
      title={alt ? "On the 16.5% alt rate" : "Consecutive approved weeks under $7,500"}
      className={`inline-flex mt-1 items-center px-2 py-0.5 text-[10.5px] rounded-full border font-semibold ${
        alt ? "bg-[#fff4e5] text-[#9a5b00] border-[#f5d49a]" : "bg-[#f5f6f8] text-[#4b5563] border-[#e7e9ee]"
      }`}
    >
      {status.label}{alt ? " · 16.5%" : ""}
    </div>
  );
};

export const RateOverrideBadge = ({ pct, testId }) => {
  if (pct === null || pct === undefined) return null;
  return (
    <div data-testid={testId}
         className="inline-flex mt-1 ml-1 items-center px-2 py-0.5 text-[10.5px] rounded-full border font-semibold bg-[#e8f3fb] text-[#005a94] border-[#b9dcf2]">
      Rate override: {pct}% flat
    </div>
  );
};
